import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {PricePlanDetailsModel} from "../models/price-plan-details.model";

@Injectable({providedIn: 'root'})
export class PricePlansHttpService {

  private base_url = `/priceplansBundle`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getPricePlanDetails(pricePlanId: string): Observable<PricePlanDetailsModel> {
    return this.http.get<PricePlanDetailsModel>(`${this.base_url}/${pricePlanId}/details`);
  }

}
